import { render } from "./ChildElement.vue?vue&type=template&id=621d589d&scoped=true"
import script from "./ChildElement.vue?vue&type=script&lang=js"
export * from "./ChildElement.vue?vue&type=script&lang=js"

import "./ChildElement.vue?vue&type=style&index=0&id=621d589d&lang=scss&scoped=true"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-621d589d"]])

export default __exports__